import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({setFilters, filters, sosHistoryActions, sosHistoryProtectionPrograms, sosHistoryCitizens, sosHistoryCreatedBy, sosHistoryResponsible}) => {

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className="space-y-4">

                        <InputDateTime
                            id="dtStart"
                            label="Data inicial *"
                            selected={filters.dtStart}
                            onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="L"
                        />

                        <InputDateTime
                            id="dtEnd"
                            label="Data final *"
                            selected={filters.dtEnd}
                            onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="L"
                        />

                        <SelectComponent
                            id={'actions'}
                            label='Ações'
                            isMulti={true}
                            options={sosHistoryActions}
                            value={filters.actions}
                            onChange={(value) => setFilters(prev => ({...prev, actions: value}))}
                            classNameWrapper={"w-full"}
                            isClearable={true}
                        />

                        <SelectComponent
                            id={'programs'}
                            label='Programa de proteção'
                            isMulti={true}
                            options={sosHistoryProtectionPrograms}
                            value={filters.programs}
                            onChange={(value) => setFilters(prev => ({...prev, programs: value}))}
                            classNameWrapper={"w-full"}
                            isClearable={true}
                        />

                        <SelectComponent
                            id={'citizenId'}
                            label='Cidadão/Empresa'
                            isMulti={false}
                            options={sosHistoryCitizens}
                            value={filters.citizenId}
                            onChange={(value) => setFilters(prev => ({...prev, citizenId: value}))}
                            classNameWrapper={"w-full"}
                            isClearable={true}
                        />

                        <SelectComponent
                            id={'createdByIds'}
                            label='Cadastrado por'
                            isMulti={true}
                            options={[{label: "Não informado", value: "SYSTEM"}, ...sosHistoryCreatedBy]}
                            value={filters.createdByIds}
                            onChange={(value) => setFilters(prev => ({...prev, createdByIds: value}))}
                            classNameWrapper={"w-full"}
                            isClearable={true}
                        />

                        <SelectComponent
                            id={'responsibleIds'}
                            label='Realizado por'
                            isMulti={true}
                            options={sosHistoryResponsible}
                            value={filters.responsibleIds}
                            onChange={(value) => setFilters(prev => ({...prev, responsibleIds: value}))}
                            classNameWrapper={"w-full"}
                            isClearable={true}
                        />

                </form>
            </div>
        </>
    );
};

export default Filters;